import React, { lazy, Suspense } from 'react';
import { useAgencyCapabilities } from '../../shared/agency/AgencyEntry';
const Workspace = lazy(() => import('./DriverAgencyWorkspace'));

export default function DriverAgencyEntry({ onBack }) {
  const caps = useAgencyCapabilities();
  if (!caps) return <p role="status">Consultando tus despachos…</p>;
  if (!caps.enabled || caps.role !== 'driver') return <div><button onClick={onBack}>Volver</button><p>No se pudo abrir despachos. Comprueba la conexión y tu asignación.</p></div>;
  return <Suspense fallback={<p role="status">Cargando despachos…</p>}><Workspace caps={caps} onBack={onBack} /></Suspense>;
}
